import React from "react";

const HomePage = ({ setCurrentPage }) => {
	return (
		<div className="container">
			<div className="hero">
				<div className="hero__left">
					<div>
						<h1>Nemec Family Christmas Cards</h1>
						<h2>Ghosts of Christmas past</h2>
						<p>
							For those of you who want to read my once-a-year missive <br />
							(or last year's) here it is.
							<br />
							<br />
							A couple of videos to the right for your viewing pleasure...
							<br />
							<br />I haven't shot many videos this year, so most of these are
							vintage.
						</p>
						<br />
						<a
							href="#"
							onClick={(e) => {
								e.preventDefault();
								setCurrentPage("2025");
							}}
						>
							See This Years Card
						</a>
					</div>
				</div>
				<div className="hero__right">
					<div>
						<iframe
							width="560"
							height="315"
							src="https://www.youtube.com/embed/C8ooEcD5kXM"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
						></iframe>
					</div>
					<div>
						<iframe
							width="560"
							height="315"
							src="https://www.youtube.com/embed/uqC9ZOg71-E"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
						></iframe>
					</div>
				</div>
			</div>

			<div className="video">
				<div className="video__left">
					<p>Pythagorean Pfunny</p>
					<iframe
						width="560"
						height="200"
						src="https://www.youtube.com/embed/E2vLJoIPH8A"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					></iframe>
				</div>
				<div className="video__middle">
					<p>Kitten Collage (watch to the end)</p>
					<iframe
						width="560"
						height="200"
						src="https://www.youtube.com/embed/xQoarkc0HNg"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					></iframe>
				</div>
				<div className="video__right">
					<p>Trampoline at Eddies</p>
					<iframe
						width="560"
						height="200"
						src="https://www.youtube.com/embed/_AoeCg2QllI"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					></iframe>
				</div>
			</div>
		</div>
	);
};

export default HomePage;
